import { MultiSportMarkStack } from '../../components/ui/SportMarks';

export function MoreSportsTeaser() {
  return (
    <div className="flex items-center gap-[13px] rounded-[22px] border border-dashed border-black/[0.14] bg-wash p-[15px_16px]">
      <MultiSportMarkStack />
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-bold tracking-tight text-ink">Basketball, Tennis &amp; more</div>
        <div className="mt-px text-[12px] font-medium text-ink2">Landing this season</div>
      </div>
      <span className="shrink-0 rounded-full bg-fill2 px-[13px] py-[7px] text-[11.5px] font-bold text-ink3">
        Coming soon
      </span>
    </div>
  );
}
